export const SOCIAL_LINKS = [
  {
    name: 'Instagram',
    handle: '@instrumentalhealthuk',
    url: 'https://www.instagram.com/instrumentalhealthuk/',
  },
  {
    name: 'Facebook',
    handle: 'Instrumental Health',
    url: 'https://www.facebook.com/profile.php?id=100063656606314',
  },
  {
    name: 'LinkedIn',
    handle: 'Kandake Makonnen',
    url: 'https://www.linkedin.com/in/kandake-makonnen-a652b371/',
  },
] as const

export type SocialName = (typeof SOCIAL_LINKS)[number]['name']
